var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import "./StackElementComponent";
import { defaults, surfaceContainerColor } from "../style";
let StackComponent = class StackComponent extends LitElement {
    get highlightGlobals() {
        return this.frame.stack_to_render.every(stackElement => !stackElement.is_highlighted);
    }
    get updateComplete() {
        return Promise.all(Array.from(this.shadowRoot.querySelectorAll(`tc-stack-element`))
            .map(el => el.updateComplete)).then(() => super.updateComplete);
    }
    addHighlightInfoToEvent(event, highlight) {
        event.detail.highlight = highlight;
    }
    render() {
        return html `
            <tc-stack-element 
                class="${this.highlightGlobals ? "highlight" : ""}"
                .locals=${this.frame.globals}
                .ordered_locals=${this.frame.ordered_globals}
                label="Global frame"
                @add-reference=${(event) => this.addHighlightInfoToEvent(event, this.highlightGlobals)}
            ></tc-stack-element>
            ${this.frame.stack_to_render.map(stackElement => html `
                <tc-stack-element
                    class="${stackElement.is_highlighted ? "highlight" : ""} ${stackElement.is_zombie ? "mute" : ""}"
                    .locals=${stackElement.encoded_locals}
                    .ordered_locals=${stackElement.ordered_varnames}
                    label="${stackElement.func_name}"
                    @add-reference=${(event) => this.addHighlightInfoToEvent(event, stackElement.is_highlighted)}
                ></tc-stack-element>
            `)}
        `;
    }
};
StackComponent.styles = [defaults, css `
          .highlight {
              background-color: ${surfaceContainerColor};
              --tc-surface-color: ${surfaceContainerColor};
          }
          
          .mute {
              opacity: 0.5;
          }
    `];
__decorate([
    property({ type: Object })
], StackComponent.prototype, "frame", void 0);
StackComponent = __decorate([
    customElement('tc-stack')
], StackComponent);
export { StackComponent };
//# sourceMappingURL=StackComponent.js.map